export var Sizes = {
  Small: 12,
  Medium: 16,
  Large: 24,
  XLarge: 32
};
export var Types = {
  Primary: 'BUTTON/PRIMARY',
  Secondary: 'BUTTON/SECONDARY',
  Tertiary: 'BUTTON/TERTIARY',
  Full: 'BUTTON/FULL',
  PrimaryPill: 'BUTTON/PRIMARY_PILL',
  SecondaryPill: 'BUTTON/SECONDARY_PILL',
  TertiaryPill: 'BUTTON/TERTIARY_PILL',
  FlatPrimary: 'BUTTON/FLAT_PRIMARY',
  FlatSecondary: 'BUTTON/FLAT_SECONDARY',
  Plain: 'BUTTON/PLAIN'
};
export var States = {
  Default: 'BUTTON/DEFAULT',
  Loading: 'BUTTON/LOADING',
  Success: 'BUTTON/SUCCESS',
  Error: 'BUTTON/ERROR'
};
export var Padding = {
  None: 'BUTTON/PADDING/NONE',
  Default: 'BUTTON/PADDING/DEFAULT',
  Wide: 'BUTTON/PADDING/WIDE'
};